const Cont = () => {
    return (
    <div>
      <h3>Welcome to the Contacts Page. All of you can reach me out, the Developer of this Web App @ ARPAN CHOUDHURY (BCREC) ( Web Dev| DS| ML) using the contact info. given below</h3>
      <ol>
      <li><u><b>Email:- </b></u><br />arpanchoudhury.iitjee@gmail.com</li>
      <br />
      <li><a href="https://www.linkedin.com/in/arpan-choudhury-2084b9200"><button style = {{borderRadius: "1%", backgroundColor: 'orange', color: 'brown', fontWeight: 'bold',  cursor: 'crosshair'}}><b>LinkedIn</b></button></a></li>
      <br />
      <li><a href="https://github.com/DataWorker2001"><button style = {{borderRadius: "1%", backgroundColor: 'orange', color: 'brown', fontWeight: 'bold', cursor: 'crosshair'}}><b>GitHub</b></button></a></li>
      </ol>
      <br />
      <br />
      <br />
      <br />
      <h2 style = {{textAlign: 'center'}}>----------x---------- END OF CONTACT PAGE ----------x----------</h2>
    </div>
  );
};

export default Cont;

